import { render, staticRenderFns } from "./BankUndepositedFundSummary.vue?vue&type=template&id=018278d5"
import script from "./BankUndepositedFundSummary.vue?vue&type=script&lang=js"
export * from "./BankUndepositedFundSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('018278d5')) {
      api.createRecord('018278d5', component.options)
    } else {
      api.reload('018278d5', component.options)
    }
    module.hot.accept("./BankUndepositedFundSummary.vue?vue&type=template&id=018278d5", function () {
      api.rerender('018278d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bankundepositedfund/BankUndepositedFundSummary.vue"
export default component.exports